// fichier des filtres

import Vue from "vue";

//formate un flotant avec les options d'affichage de la langue (virgule, espace des miliers...)
Vue.filter("numLocal", value => {
  const amt = Number(value);
  return (
    (amt && amt.toLocaleString(undefined, { maximumFractionDigits: 1 })) || "0"
  );
});

// formate un flotant en entier avec arrondis à l'entier sup
Vue.filter("intLocal", value => {
  //const amt = Number(value);
  return Math.abs(Math.round(parseFloat(value)));
});

// Transforme un texte pour mettre une majsucule à la première lettre du premier mot de la chaine
Vue.filter('capitalize', value => {
  if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
});
